
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/avatar-dialog-view/jst/gravatarView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<img class=\"content-box gravatar-preview-image\" aria-label=\"gravatar\"></img>\n<div class=\"content-box-mini gravatar-label\">\n  <label for=\"gravatar-preview-input\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<a href=\"http://gravatar.com/\" target=\"_blank\">$1</a>"),
    'i18n_scope': ("profiles.gravatar_view")
  },data:data},helper ? helper.call(depth0, "profiles.gravatar_view.enter_gravatar_email_below", "enter your *Gravatar* email address below", options) : helperMissing.call(depth0, "t", "profiles.gravatar_view.enter_gravatar_email_below", "enter your *Gravatar* email address below", options)))
    + "\n  </label>\n</div>\n<div class=\"input-append\">\n  <input type=\"text\" class=\"gravatar-preview-input\" id=\"gravatar-preview-input\" />\n  <button class=\"btn gravatar-preview-btn\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("profiles.gravatar_view")
  },data:data},helper ? helper.call(depth0, "profiles.gravatar_view.button.preview", "Preview", options) : helperMissing.call(depth0, "t", "profiles.gravatar_view.button.preview", "Preview", options)))
    + "\n  </button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  